import Channel from "../models/Channel";
import { ChannelType } from "../models/ChannelType";
import { TAG_SPECIAL } from "../models/Constants";
import Device from "../models/Device";
import Signal from "../models/Signal";
import { determineChannelTypes } from "./determineChannelTpyes";

export function mergeAllSpecialSiganls(
  device: Device,
  channels: Array<Channel>,
  allSignals: Array<Signal>,
): Array<Channel> {
  const res = [...channels];
  const rest = new Array<Signal>();

  const allSignalsInChannels = new Array<Signal>();

  for (const channel of channels) {
    let channelType = channel.channelType;

    if (channelType != ChannelType.General) {
      //      if (channelType != ChannelType.Unknown && channelType != ChannelType.General) {
      allSignalsInChannels.push(...channel.signals.asArray());
    }
  }

  for (const signal of allSignals) {
    if (!allSignalsInChannels.find((s) => s.number == signal.number)) {
      // if (!signal.isDummySignal ) {
      //   rest.push(signal);
      // }
      rest.push(signal);
    }
  }

  let specialSiganlsChannel = channels.find((c) => c.tag == TAG_SPECIAL);
  if (!specialSiganlsChannel) {
    specialSiganlsChannel = device.createNewKnxChannel({ tag: TAG_SPECIAL, channelType: ChannelType.Special }, device);
    res.push(specialSiganlsChannel);
  }

  for (const signal of rest) {
    specialSiganlsChannel.addSignalWithoutUpdate(signal);
  }

  return res;
}

export function merge_TX_S_Channels(channels: Array<Channel>): Array<Channel> {
  const res = [...channels];

  const sameChannels = channels.filter((c) => c.tag == TAG_SPECIAL);

  if (sameChannels.length > 1) {
    const mainChannel = sameChannels[0];
    mainChannel.channelType = ChannelType.Special;

    for (let i = 1; i < sameChannels.length; i++) {
      const ch = sameChannels[i];
      const index = res.indexOf(ch);
      if (index >= 0) {
        res.splice(index, 1);
      }
      ch.signals.asArray().forEach((signal) => {
        signal.parent = mainChannel;
        ch.signals.removeWithoutUpdate(signal);
        mainChannel.signals.addWithoutUpdate(signal);
      });
    }
  }

  return res;
}

export function merge_Blind_Channels_for_Buttons(channels: Array<Channel>): Array<Channel> {
  const res = [...channels];

  const longPressChannels = channels.filter((c) => c.tag.endsWith("_l"));

  for (const ch of longPressChannels) {
    const mainTag = ch.tag.substring(0, ch.tag.length - 2);
    const mainChannel = channels.find((c) => c.tag == mainTag);

    if (mainChannel) {
      if (mainChannel) {
        //
        // check if there is a type overlap between the main channel and the long press channel
        // in the way that the long press channel has a signal of the same type as the main channel
        //
        let siganlAfterTypeOverlap = false;
        for (const s1 of mainChannel.signals) {
          siganlAfterTypeOverlap ||= ch.signals.findFirst((s2) => s1.type.name == s2.type.name) != undefined;
        }

        //
        // if the is no overlap we merge the long press channel into the main channel
        // becauses this is for sure a misdetection in the script
        //

        if (!siganlAfterTypeOverlap) {
          //
          // move all signals to main channel
          //
          for (const signal of ch.signals.asArray()) {
            signal.parent = mainChannel;
            mainChannel.signals.addWithoutUpdate(signal);
            ch.signals.removeWithoutUpdate(signal);
          }

          //
          // ChannelType my change
          // ie: "switch to dim" because the longPress siganl is "DimStep"
          //
          determineChannelTypes([mainChannel], false);

          //
          // remove long press channel
          //
          const idx = res.indexOf(ch);
          if (idx >= 0) {
            res.splice(idx, 1);
          }
        }
      }
    }
  }

  return res;
}
